<div class="heroBackground">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-7">
                <div class="heroTxt">
                    <h1 class="font-weight--reguler text-white mb-15"><span class="mlTitle">
                        AI, IT Solutions & Consulting </span></h1>
                    <p>We are continuously working toward innovating the startup products and creating the impact with digital transformation.
                        Some of our produtcs liveonlinetraining.in | citygossiper.com | Help2Consumer.com</p>
                </div>
                <div class="heroButton">
                    <button><a href="#products">Explore our Products</a></button>
                    <a href="http://liveonlinetraining.in/" target="_blank"><span><i class="fa fa-play-circle"></i>liveonlinetraining.in</span></a>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-12">
                <div class="heroBrandLogo">
                    <div class="brandLogoImage">
                        <img class="image1" src="assets/images//brandLogo1.png" alt="Logo1">
                        <img src="assets/images//brandLogo2.png" alt="">
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>
<div class="numericDataWrapper">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="numericDataTxt">
                    <h1>100+</h1>
                    <h6>Happy clients</h6>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="numericDataTxt">
                    <h1>300+</h1>
                    <h6>Finished projects</h6>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="numericDataTxt">
                    <h1>60+</h1>
                    <h6>Skilled Experts</h6>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="numericDataTxt">
                    <h1>10+</h1>
                    <h6>Media Posts</h6>
                </div>
            </div>
        </div>
    </div>
</div>